"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isQuizModuleCorrect(moduleStat) {
    return moduleStat.mark === moduleStat.marksTotal;
}
exports.default = isQuizModuleCorrect;
